import {Box} from '@mui/material';
import AppCard from 'main/core/AppCard';
import PropTypes from 'prop-types';
import DocBody from './DocBody';
import DocEmpty from './DocEmpty';
import DocFooter from './DocFooter';
import DocHeader from './DocHeader';

const DocTemplate = ({widgetSpec, widgetData, notSuccess}) => {
  return (
    <AppCard
      sxStyle={{
        minHeight: '29.7cm', // A4 size
        maxWidth: 900,
        width: '100%',
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: (theme) => `${theme.sharpRadiu}px`,
        boxShadow: (theme) => theme.palette.contextMenuShadow,

        '@media print': {
          '@page': {
            size: 'A4 portrait', // Allows printer setting layout (Landscape/Portrait) to dictate size
            margin: '0mm', // Removes default browser headers/footers (Date, URL, Title)
          },
          '*': {
            WebkitPrintColorAdjust: 'exact !important',
            printColorAdjust: 'exact !important',
          },
          boxShadow: 'none',
          p: 0,
          m: 0,
          width: '100%',
          borderRadius: 0,
          border: 'none',
        },
      }}
      contentStyle={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        p: 0,
      }}
    >
      {notSuccess ? (
        <DocEmpty />
      ) : (
        <Box
          sx={{
            p: {xs: 6, xl: 10},
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
          }}
        >
          <DocHeader widgetSpec={widgetSpec} widgetData={widgetData} />

          <DocBody bodySpec={widgetSpec.body} widgetData={widgetData} />

          <Box sx={{flexGrow: 1, minHeight: 20}} />

          <DocFooter widgetSpec={widgetSpec} widgetData={widgetData} />
        </Box>
      )}
    </AppCard>
  );
};

DocTemplate.displayName = 'DocTemplate';

DocTemplate.propTypes = {
  widgetSpec: PropTypes.object,
  widgetData: PropTypes.object,
  notSuccess: PropTypes.bool,
};

export default DocTemplate;
